import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=7d1f8057&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=7d1f8057&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f8057",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1f8057')) {
      api.createRecord('7d1f8057', component.options)
    } else {
      api.reload('7d1f8057', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=7d1f8057&scoped=true&", function () {
      api.rerender('7d1f8057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onlineStore/chat/component/avatar.vue"
export default component.exports